<template></template>
<script>
import Swal from 'sweetalert2'
export default {
  props: {
    config: Object,
  },
  data() {
    return {
      defaults: {
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        ...this.config
      }
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        if (this.flash && this.flash.success) {
          Swal.fire({
            title: this.flash.success,
            icon: 'success',
            ...this.defaults
          })
          return
        }
        if (this.flash && this.flash.error) {
          Swal.fire({
            title: this.flash.error,
            icon: 'error',
            ...this.defaults
          })
          return
        }
      },
      deep: true,
    },
  },
  computed: {
    flash() {
      return this.$page.props.flash
    }
  },
}
</script>